import { useMemo } from 'react';

import { RangePickerSelection } from '@cast/shared-search-ui';

import { determineCorrectDateFromPresetOrRange } from '@cast/shared-date-ui';

type DateRange = {
  fromDate?: string;
  toDate?: string;
};

export const useDatePresetValue = (
  dateRange: RangePickerSelection,
  allowTimeInput = false
): DateRange => {
  const preset = dateRange?.preset;

  const { from, to } = useMemo(() => {
    return determineCorrectDateFromPresetOrRange({
      preset,
      timezone: dateRange.timezone,
      from: dateRange.fromDate,
      to: dateRange.toDate,
      allowTimeInput,
    });
  }, [
    allowTimeInput,
    dateRange.fromDate,
    dateRange.timezone,
    dateRange.toDate,
    preset,
  ]);

  return {
    fromDate: from,
    toDate: to,
  };
};
